export const CubeMark = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="cm-t" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#5b8cf5" /><stop offset="1" stopColor="#2f5be6" /></linearGradient>
      <linearGradient id="cm-l" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#f7893a" /><stop offset="1" stopColor="#e5401a" /></linearGradient>
      <linearGradient id="cm-r" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#5fd0fa" /><stop offset="1" stopColor="#2b9be8" /></linearGradient>
    </defs>
    <path d="M50 5 89 27 50 49 11 27Z" fill="url(#cm-t)" />
    <path d="M9 31 48 53V96L9 74Z" fill="url(#cm-l)" />
    <path d="M52 53 91 31V74L52 96Z" fill="url(#cm-r)" />
    <path d="M50 15c-3 5-6 8-6 12a6 6 0 0 0 12 0c0-4-3-7-6-12Z" fill="#fff" />
    <path d="M28 56c-5 5-7 9-7 13 0 4 3 7 7 7s7-3 7-7c0-3-1-5-3-7 0 2-1 3-2 3 0-3 0-6-2-9Z" fill="#fff" />
    <path d="M71 52v24M61 58l20 12M81 58 61 70" stroke="#fff" strokeWidth="4" strokeLinecap="round" />
  </svg>
);

export const Wordmark = ({ className = "" }) => (
  <span className={`font-display-n font-black italic tracking-tight leading-none ${className}`}>
    <span className="text-white">TERMO</span><span className="text-[#ff5500]">ONLINE</span>
  </span>
);

export const Logo = ({ size = "md" }) => (
  <span className="inline-flex items-center gap-2.5">
    <CubeMark className={size === "lg" ? "w-11 h-11" : "w-8 h-8"} />
    <Wordmark className={size === "lg" ? "text-2xl" : "text-lg"} />
  </span>
);
